import { SCHEDULING_URL_ATTRIBUTE_NAME } from '@src/constants';
import { LocationAttribute } from '@src/lib/__generated/vetspire/sdk';

export const findSchedulingUrl = (attributes: LocationAttribute[]) =>
	attributes.find(({ customAttribute }) => customAttribute?.name === SCHEDULING_URL_ATTRIBUTE_NAME)?.value || null;
